import { ListItem, ListItemAvatar, Avatar, ListItemText, Divider, Button } from "@mui/material";
import List from "@mui/material/List/List";
import Paper from "@mui/material/Paper";
import WatchIcon from "@mui/icons-material/Watch";
import { EmailOutlined } from "@mui/icons-material";
import StarsIcon from "@mui/icons-material/Stars";
import SmallText from "../../../components/Smalltext";

interface Props {
  phoneNumber: string | undefined;
  email: string | undefined;
}

const ActivationInfoCard = ({ email, phoneNumber }: Props) => (
  <Paper
    sx={{
      width: "80%",
      maxWidth: 400,
      borderRadius: 5,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
    elevation={3}
  >
    <List sx={{ width: "100%", my: "7px" }}>
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <EmailOutlined />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Email" secondary={email} primaryTypographyProps={{ fontSize: { xs: "14px", sm: "" } }} />
      </ListItem>

      <Divider variant="inset" component="li" />

      <ListItem
        secondaryAction={<Button onClick={() => navigator.clipboard.writeText(phoneNumber ?? "")}>Copy</Button>}
      >
        <ListItemAvatar>
          <Avatar>
            <WatchIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary="JrTrack phone number:"
          secondary={phoneNumber}
          primaryTypographyProps={{ fontSize: { xs: "14px", sm: "" } }}
          secondaryTypographyProps={{ color: "", sx: { fontWeight: 600 } }}
        />
      </ListItem>

      <Divider variant="inset" component="li" />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          marginLeft: "5%",
          marginTop: "1%",
        }}
      >
        <StarsIcon fontSize="inherit" sx={{ mb: "2%", mr: "2px" }} color="secondary" />
        <SmallText color="secondary">Copy to add it to your contact list.</SmallText>
      </div>
    </List>
  </Paper>
);

export default ActivationInfoCard;
